import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { isAnyLocation, makeSearchUrl, useSearchParams } from '../../../helpers';
import { hasDateRange, setSearchRange } from './DatePicker/helpers';

import moment from 'moment';
import { useSearchTag } from '../../../../tag-manager/search.tag';
import { SearchIcon } from '../../../styles';
import DatePicker from './DatePicker';
import Guests from './Guests';
import Location from './Location';
import { SearchButton, SearchWrapper } from './styles';

const DATE_FORMAT = 'YYYY-MM-DD';

export default function Search() {
  const { location, guests, start: startDate, end: endDate } = useSearchParams();
  const initialLocation = isAnyLocation(location) ? '' : location;
  const [verifiedLocation, setVerifiedLocation] = useState(initialLocation); // value submitted
  const [numGuests, setNumGuests] = useState(Number(guests) || '');
  const [dateRange, setDateRange] = useState(setSearchRange(startDate, endDate));

  const history = useHistory();

  const onSubmitClick = async () => {
    try {
      // No dates picked: send 'none', so the search has no date filter.
      const hasDates = hasDateRange(dateRange);
      useSearchTag({
        startDate: hasDates ? moment(dateRange.startDate).format(DATE_FORMAT) : 'none',
        endDate: hasDates ? moment(dateRange.endDate).format(DATE_FORMAT) : 'none',
        location: verifiedLocation,
        numGuests
      });

      history.push(
        makeSearchUrl({
          location: verifiedLocation,
          start: hasDates ? dateRange.startDate : 'none',
          end: hasDates ? dateRange.endDate : 'none',
          guests: numGuests
        })
      );
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <SearchWrapper>
      <Location setVerifiedLocation={setVerifiedLocation} initialLocation={initialLocation} />

      <DatePicker dateRange={dateRange} setDateRange={setDateRange} />

      <Guests numGuests={numGuests} setNumGuests={setNumGuests} />

      <SearchButton onClick={onSubmitClick}>
        <SearchIcon />
      </SearchButton>
    </SearchWrapper>
  );
}
